import { initHyGraphClient, Project } from '@seek/cmsu-cms-connect';

import {
  ENV_DEV,
  ENV_PRODUCTION,
  ENV_STAGING,
} from 'src/constants/environments';

const getHygraphEnv = () => {
  switch (window.ADV_SHOPFRONT_CONFIG.environment) {
    case ENV_DEV:
      return Project.ApacDev;
    case ENV_STAGING:
      return Project.ApacStg;
    case ENV_PRODUCTION:
      return Project.Apac;
    default:
      return Project.Apac;
  }
};

const getClient = () => {
  const hygraphenv = getHygraphEnv();
  const client = initHyGraphClient(hygraphenv);
  return client;
};

export default getClient;
